export default {
    introduction: {
        img: "https://web-data.zmlearn.com/image/qoAdAHUHPobnSK3w79A6Cv/img_banner_text%402x.png",
    },
    info: {
        title: `<h1>A  <span> rigorous </span> tutor selection process</h1>`,
        button: 'Get a FREE 1-on-1 Lesson',
        bImg: 'https://web-data.zmlearn.com/image/4Czvb3ijHP6WSeRrYv8HjM/img_P1%402x.png',
        sImg: 'https://web-data.zmlearn.com/image/gZVLYV7s2FPUDWFEYqZ6hS/img_P1_3x.png',
    },
    teach: {
        title: '<h1>Student-<span>centered</span> Teaching</h1>',
        desc: 'Our tutors are all-compassionate and provide motivation as well as a good learning atmosphere.',
    },
    trice: {
        title: `<h1>Always <span>flexible</span> and<p>reliable</p></h1>`,
        title1: `<h1>Always <span>flexible</span> and<p>&nbsp;reliable</p></h1>`,
        desc: 'AirClass always match you with the most suitable and experienced tutor to make your learning fun and enjoyable.'
    },
    tutors: {
        title: '<h1>Airclass  <p>Tutors</p></h1>',
        list: [
            {
                id: 1,
                name: 'Ada',
                school: 'Cambridge University',
                subject: 'Math',
                experience: '10+ years',
                introduction: `Hello, I am committed to helping students whichever way I can. I have experience in formal tutoring for 10 years.Education is not the filling of a pail, but the lighting of a fire. I am very happy to adapt my lesson plan to suit your needs, for example if you have a certain area you would like to cover.`,
                img: 'https://web-data.zmlearn.com/image/tEArepTqxnbSKvxkVR5PBf/img_ada%402x.png',
                evid: ''
            },
            {
                id: 2,
                name: 'Belal',
                school: 'Herat University',
                subject: 'Coding',
                experience: '9 years',
                introduction: `I am an experienced web developer with a demonstrated history of working in the computer software industry. Skilled in Python, Web Development,  Strong engineering！ I love kids and I enjoy teaching coding:) !`,
                img: 'https://web-data.zmlearn.com/image/ri6ZpmshdSdyBDoCFWNfgQ/img_belal%402x.png',
                evid: ''
            },
            {
                id: 3,
                name: 'Lupo',
                school: 'University of London',
                subject: 'Chemistry',
                experience: '10+ years',
                introduction: `Hi! I'm Lupo. My main goal with students is to get them to work confidently and eventually be independent. It will be a gradual process of slowly backing away and allowing them to answer the questions on their own while still being there in case they need a nudge in the right direction.`,
                img: 'https://web-data.zmlearn.com/image/vmyWJyqcLG5JZDfYGYUmVg/img_lupo%402x.png',
                evid: ''
            },
            {
                id: 4,
                name: 'Qhawekazi',
                school: 'University of Fort Hare',
                subject: 'Music',
                experience: '9 years',
                introduction: `I am a musician by profession and by passion and a recent music graduate. I love exploring and learning new skills and encourages my students to do the same; to be creative and passionate about music!`,
                img: 'https://web-data.zmlearn.com/image/cyod2of6PzVcjMjqcErxFE/img_qhawekazi%402x.png',
                evid: ''
            },
            {
                id: 5,
                name: 'Onil',
                school: 'University de los Andes',
                subject: 'Biology',
                experience: '7+ years',
                introduction: `Hello, my name is Onil. I am a fun, patient, and engaging tutor. I have an array of experience and can provide tutoring across all of the core subjects. In particular, I can aid in exam technique, subject content, and general approach to tackling KS3, GCSEs, and some A levels.`,
                img: 'https://web-data.zmlearn.com/image/fC7uF1C8QdFofKSfpfwjzm/img_P4_onil%402x.png',
                evid: ''
            },
            {
                id: 6,
                name: 'Judith',
                school: 'North West University of Potchefstroom',
                subject: 'Science',
                experience: '5 years',
                introduction: `My focus is to help students master their subject, not just understand it. By doing this, we will home in on the areas they are most uncomfortable with and encourage them to also seek such answers themselves. I also deliver engaging sessions.`,
                img: 'https://web-data.zmlearn.com/image/eRttjjhZHXW8ueQk3uD45Z/img_judith%402x.png',
                evid: ''
            },
            {
                id: 7,
                name: 'Yi',
                school: 'Academy of Fine Art of Macerata',
                subject: 'Arts',
                experience: '3 years',
                introduction: `I got my bachelor's and master's degree in Decoration at the Academy of fine arts in Italy. I believe that a good teacher should feel this uniqueness and owns the capacity to guide the student towards an enjoyable and enriching experience.`,
                img: 'https://web-data.zmlearn.com/image/fUmCGraib9YPqCb8NFSZpu/img_yi%402x.png',
                evid: ''
            },
            {
                id: 8,
                name: 'Edward',
                school: 'University of Birmingham',
                subject: 'History',
                experience: '8 years',
                introduction: `Hi, I'm Edward! I love to teach, because it allows me to share my loves and interests with students, hear their perspectives and watch them achieve their goals!
                I am attentive, focused, well-read and love watching students become passionate about new ideas!`,
                img: 'https://web-data.zmlearn.com/image/jWbfd5inNjt4urQbvjTLYx/img_edward%402x.png',
                evid: ''
            },
            {
                id: 9,
                name: 'Enrique',
                school: 'University of Nottingham',
                subject: 'Physics',
                experience: '3+ years',
                introduction: `Hello, I'm Enrique. My main focus is to give you lessons that are tailored for you. I plan to teach you concepts in a simple and straightforward way, tackling it from different angles if needed. We will then practice our understanding of what we learnt through questions and past exam papers.`,
                img: 'https://web-data.zmlearn.com/image/vC1DNmRdUJESM5LRz5tDya/img_enirque%402x.png',
                evid: ''
            },
            {
                id: 10,
                name: 'Carol',
                school: 'Nelson Mandela Metropolitan University',
                subject: 'English',
                experience: '10+ years',
                introduction: `Hi, I'm Carol and I'm pround when my students get improvement. There is no one size fits all when it come to tutoring - each student has different requirements that ought to be considered. `,
                img: 'https://web-data.zmlearn.com/image/uvt2DPn6SXrffhpSbWNULB/img_carol%402x.png',
                evid: ''
            },
            {
                id: 11,
                name: 'Hayk',
                school: 'Imperial College London',
                subject: 'Math',
                experience: '6 years',
                introduction: `I’ve always loved maths. And anything maths related. I have been tutoring for around 6 years now. I understand how hard it can be for people to learn and how useful using modern techniques to teach is.`,
                img: 'https://web-data.zmlearn.com/image/hjehdgD8aE87aY9JRcZVHp/img_hayk%402x.png',
                evid: ''
            },
            {
                id: 12,
                name: 'Rosha',
                school: 'University of Leeds',
                subject: 'Maths',
                experience: '4 years',
                introduction: `I'm Rosha and I've always been very passionate about Mathematics and really enjoyed the subject. I'm interested in the importance of the applications of Mathematics which really motivated me to study the subject further. I really hope to motivate my students in the same way, through my lessons.`,
                img: 'https://web-data.zmlearn.com/image/8LVV9dCUCKb4y9gB1QqHJj/img_rosha%402x.png',
                evid: ''
            },
        ]
    },
    trial: {
        title: '<h1>Interested in a <span> free trial lesson  </span> with one of our trial? </h1>'
    }
}